import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Badge/badge';
export var Badge = function Badge(_a) {
  var _a$isRead = _a.isRead,
      isRead = _a$isRead === void 0 ? false : _a$isRead,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? '' : _a$children,
      props = __rest(_a, ["isRead", "className", "children"]);

  return React.createElement("span", Object.assign({}, props, {
    className: css(styles.badge, isRead ? styles.modifiers.read : styles.modifiers.unread, className)
  }), children);
};